import { Component, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subject, Subscription } from 'rxjs';
import { GasTwo } from '../../../models/gastwo.model';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { GasTwoService } from '../../../services/gatwo.service';

@Component({
    selector: 'gastwo-overview',
    template: require('./gastwo-overview.component.html'),
    styles: [require('./gastwo-overview.component.css')],
    animations: [fadeInOut]
})
export class GasTwoOverviewComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    loading: boolean;

    pagingData: GasTwo[] = [];
    currentPage = 1;
    pageSize = 20;
    search = '';
    totalRecords = 0;
    orderByField = 'Date';
    isDesc = false;
    modelChanged = new Subject<string>();

    constructor(private accountService: AccountService, private gastwoService: GasTwoService, private alertService: AlertService, private ngxLogger: NGXLogger) { }

    ngOnInit() {
        const modelSub = this.modelChanged.debounceTime(500)
            .subscribe(() => {
                this.initializeDataListByPage(1);
            });
        this.subscribers.push(modelSub);
        this.initializeDataListByPage(1);
    }

    initializeDataListByPage(page: number) {
        this.loading = true;
        this.currentPage = page;
        const dataListByPageSub = this.gastwoService.getDataListByPage(page, this.pageSize, this.orderByField, this.isDesc, this.search)
            .subscribe((data: any) => {
                if (data && data.Item1) {
                    this.pagingData = data.Item1;
                    this.totalRecords = data.Item2;
                } else {
                    this.pagingData = [];
                    this.totalRecords = 0;
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.error(err);
                this.ngxLogger.error(err.message);
            });
        this.subscribers.push(dataListByPageSub);
    }

    globalSearch() {
        this.modelChanged.next();
    }

    paginate(event: any) {
        this.pageSize = event.rows;
        this.initializeDataListByPage(event.page + 1);
    }

    customSort(event: any) {
        let isDesc: boolean;
        if (event.order === -1) {
            isDesc = true;
        } else {
            isDesc = false;
        }
        if (event.field !== this.orderByField || isDesc !== this.isDesc) {
            this.orderByField = event.field;
            this.isDesc = isDesc;
            this.initializeDataListByPage(this.currentPage);
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get cangastwoOverviewPermission() {
        return this.accountService.userHasPermission(Permission.GasTwoOverviewPermission);
    }

    get cangastwoExportPermission() {
        return this.accountService.userHasPermission(Permission.GasTwoExportPermission);
    }

    get canaddGasTwo() {
        return this.accountService.userHasPermission(Permission.addGasTwoPermission);
    }

    get caneditGasTwo() {
        return this.accountService.userHasPermission(Permission.editGasTwoPermission);
    }

    get candeleteGasTwo() {
        return this.accountService.userHasPermission(Permission.deleteGasTwoPermission);
    }

    deleteGastwo(gastwo: GasTwo) {
        this.alertService.showDialog('Weet je zeker dat je ' + gastwo.StripName + ' wilt verwijderen ?', DialogType.confirm, () => {
            const deleteGastwoSubscriber = this.gastwoService.delete(gastwo.Id).subscribe(res => {
                this.alertService.showMessage('Klant', 'Met succes verwijderd!', MessageSeverity.success);
                this.ngOnInit();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteGastwoSubscriber);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas-two/gastwo-overview/gastwo-overview.component.ts